import { useCallback, useEffect, useState } from 'react'
import { GestorEquipeFilters } from '@/components/Gestores/GestorEquipeFilters'
import { GestorEquipeTable } from '@/components/Gestores/GestorEquipeTable'
import { GestorEquipeFeriasCalendar } from '@/components/Gestores/GestorEquipeFeriasCalendar'
import {
  gestoresService,
  type GestorEquipeFeriasCalendario,
  type GestorEquipeRow,
} from '@/services/gestoresService'
import { toast } from 'sonner'

type EquipeView = 'lista' | 'calendario'

type Props = {
  equipe: GestorEquipeRow[]
  loading?: boolean
  search: string
  onSearchChange: (v: string) => void
  onSelect: (id: string, view?: 'lista' | 'calendario') => void
  initialView?: 'lista' | 'calendario'
  onViewChange?: (view: 'lista' | 'calendario') => void
}

export function GestorEquipeTab({
  equipe,
  loading,
  search,
  onSearchChange,
  onSelect,
  initialView = 'lista',
  onViewChange,
}: Props) {
  const [view, setView] = useState<EquipeView>(initialView)
  const [calendario, setCalendario] = useState<GestorEquipeFeriasCalendario | null>(null)
  const [calendarioLoading, setCalendarioLoading] = useState(false)

  const loadCalendario = useCallback(async () => {
    setCalendarioLoading(true)
    try {
      const data = await gestoresService.listEquipeFeriasCalendario()
      setCalendario(data)
    } catch {
      toast.error('Não foi possível carregar o calendário de férias')
    } finally {
      setCalendarioLoading(false)
    }
  }, [])

  useEffect(() => {
    setView(initialView)
  }, [initialView])

  const changeView = (next: EquipeView) => {
    setView(next)
    onViewChange?.(next)
  }

  useEffect(() => {
    if (view === 'calendario' && !calendario && !calendarioLoading) {
      void loadCalendario()
    }
  }, [view, calendario, calendarioLoading, loadCalendario])

  return (
    <div className='space-y-3'>
      <GestorEquipeFilters
        search={search}
        onSearchChange={onSearchChange}
        view={view}
        onViewChange={changeView}
      />

      {view === 'lista' ? (
        <GestorEquipeTable equipe={equipe} loading={loading} onSelect={(id) => onSelect(id, 'lista')} />
      ) : calendario ? (
        <GestorEquipeFeriasCalendar
          data={calendario}
          loading={calendarioLoading}
          onSelectMember={(id) => onSelect(id, 'calendario')}
        />
      ) : (
        <GestorEquipeFeriasCalendar
          data={{ membros: [], eventos: [] }}
          loading={calendarioLoading}
          onSelectMember={(id) => onSelect(id, 'calendario')}
        />
      )}
    </div>
  )
}
